import React from 'react';
import {
  IconButton,
  Tooltip,
  Box,
  Typography,
  useTheme
} from '@mui/material';
import {
  Language as LanguageIcon,
  Translate as TranslateIcon
} from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from '../../hooks/useTranslation';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  const { t } = useTranslation();
  const theme = useTheme();

  const getLanguageFlag = (lang) => {
    switch (lang) {
      case 'en':
        return '🇺🇸';
      case 'es':
        return '🇪🇸';
      default:
        return '🌐';
    }
  };

  const getLanguageName = (lang) => {
    switch (lang) {
      case 'en':
        return 'English';
      case 'es':
        return 'Español';
      default:
        return 'Language';
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={`Switch to ${getLanguageName(language === 'en' ? 'es' : 'en')}`}>
        <IconButton
          onClick={toggleLanguage}
          sx={{
            borderRadius: 2,
            p: 1.5,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
              transform: 'scale(1.05)',
            },
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="h6" sx={{ fontSize: '1.2rem' }}>
              {getLanguageFlag(language === 'en' ? 'es' : 'en')}
            </Typography>
            <LanguageIcon sx={{ fontSize: '1.1rem' }} />
          </Box>
        </IconButton>
      </Tooltip>
      
      <Typography 
        variant="body2" 
        sx={{ 
          color: 'text.secondary',
          fontWeight: 500,
          display: { xs: 'none', sm: 'block' }
        }}
      >
        {getLanguageName(language)}
      </Typography>
    </Box>
  );
};

export default LanguageToggle;
